export const style = {
  chip: {
    container: {
      position: 'relative',
    },
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row-reverse',
      color: 'primary.text',
      position: 'relative',
      pr: 2,
      borderRadius: 20,
      '& + div': {
        display: 'none',
      },
      '.MuiChip-label': {
        pr: 0,
      },
      '&:hover + div': {
        position: 'absolute',
        top: -47,
        left: 25,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 1,
        minWidth: 300,
        bgcolor: '#130F35',
        px: 2,
        py: 1,
        borderRadius: 1,
        svg: {
          width: 20,
          heigth: 20,
        },
        '& .status-block_icon': {
          height: 24,
        },
        '& .status-block_text': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '600px',
        },
      },

    },
  },
  Typography: {
    body1: {
      color: '#fff',
      width: '100%',
    },
    caption: {
      color: 'action.active',
      width: '100%',
    },
  },
} as const;
